var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymenticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C6.0561 0 0 6.0561 0 13.5C0 20.9439 6.0561 27 13.5 27C20.9439 27 27 20.9439 27 13.5C27 6.0561 20.9439 0 13.5 0ZM17.9456 19.8545L12.15 14.0589V5.4H14.85V12.9411L19.8545 17.9456L17.9456 19.8545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymenticon);
export default __webpack_public_path__ + "static/media/paymenticon.cde1815f7caa2e8ce13b10d762d8c107.svg";
export { ForwardRef as ReactComponent };